module.exports = __webpack_public_path__ + "img/puzzle-piece-simple.b17fdf74.svg";